import store from '@/store'
import filterStore from '@/views/modules/Utils/filterStore'
import { onUnmounted, ref } from '@vue/composition-api'


export default function filter(type) {

  const FILTER_STORE = 'filter'

  if (!store.hasModule(FILTER_STORE))
    store.registerModule(FILTER_STORE, filterStore)

  onUnmounted(() => {
    if (store.hasModule(FILTER_STORE))
          store.unregisterModule(FILTER_STORE)
  })

  const ownersOptions = ref([])
  const contractsOptions = ref([])
  const contractsOptions_orig = ref([])
  const categoriesOptions = ref([])
  const groupsOptions = ref([])

  const managersOptions = ref([])
  // const rolesOptions = ref([])
  const typesOptions = ref([])


  store.dispatch('filter/getFilterOptionsBy', { type })
    .then(response => {
      const { categories, groups, contracts, owners, managers, roles, types } = response.data.data
      ownersOptions.value = owners
      contractsOptions.value = contracts
      contractsOptions_orig.value=JSON.parse(JSON.stringify(contracts))
      categoriesOptions.value = categories
      groupsOptions.value = groups
        typesOptions.value = types

      managersOptions.value = managers
      // rolesOptions.value = roles

    })


  return {
    ownersOptions,
    groupsOptions,
    categoriesOptions,
    contractsOptions,
    contractsOptions_orig,
      typesOptions,

      managersOptions,
      // rolesOptions
  }

}
